import React from 'react';
import { isEmpty, isUndefined } from 'lodash';
import classnames from 'classnames';
import { categoryShape, categoriesShape, handler, flag } from '../../shapes';
import { nullFunc } from '../../utils/helpers';

const Category = props => (
  <div className="layout__item">
    <button
      {...props}
      className={classnames('c-tag', { 'is-active': props.active, 'is-selected': props.selected })}
    />
  </div>
);
Category.propTypes = {
  active: flag,
  selected: flag,
};
Category.defaultProps = {
  active: false,
  selected: false,
};

const Categories = ({
  categories,
  setCategory,
  resetCategory,
  selectedCategory,
}) => {
  if (isEmpty(categories)) return null;

  return (
    <div className="layout layout--small layout--auto u-mb">
      <div className="layout__item u-1/1">
        <h2 className="c-heading c-heading">Categories</h2>
      </div>
      <Category
        onClick={() => resetCategory()}
        active={isUndefined(selectedCategory)}
      >
        All services
      </Category>

      { categories.map(category => (
        <Category
          onClick={() => setCategory(category.id)}
          active={category.id === selectedCategory}
          selected={category.selected}
        >
          {category.name}
        </Category>
      )) }

    </div>
  );
};
Categories.propTypes = {
  categories: categoriesShape,
  selectedCategory: categoryShape,
  setCategory: handler,
  resetCategory: handler,
};
Categories.defaultProps = {
  categories: [],
  selectedCategory: undefined,
  setCategory: nullFunc,
  resetCategory: nullFunc,
};

export default Categories;



// WEBPACK FOOTER //
// ./src/app/services/components/Categories.jsx